import {
  Toast
} from 'mint-ui';

let toast = function(title) {
  if (title) {
    Toast(title)
  }
}
export default {
  verified: function(verifing) {
    let flag = false;
    if (!verifing || verifing.length == 0) {
      return true;
    }
    for (let i = 0; i < verifing.length; i++) {
      flag = this[verifing[i].name](verifing[i].content, verifing[i].tip);
      if (!flag) {
        break;
      }
    }
    return flag;
  },
  isEmpty: function(input, tip) {
    if (input === '' || input === null || input === undefined) {
      if (input === 0) {
        return true;
      } else {
        toast(tip);
        return false;
      }
    } else {
      return true;
    }
  },
  compareDate: function(input, tip) {
    let days = input.split(';');
    let d1 = new Date(days[0]);
    let d2
    if (days.length >= 2) {
      d2 = new Date(days[1]);
    } else {
      d2 = new Date()
    }
    // console.error('compareDate', days, d1, d2);
    if (parseInt(d2 - d1) >= 0) {
      return true
    } else {
      toast(tip);
      return false;
    }
  },
	dateFormat: function(date, fmt) {
	  date = new Date(date)
	  var a = ['日', '一', '二', '三', '四', '五', '六']
	  var o = {
	    'M+': date.getMonth() + 1, // 月份
	    'd+': date.getDate(), // 日
	    'h+': date.getHours(), // 小时
	    'm+': date.getMinutes(), // 分
	    's+': date.getSeconds(), // 秒
	    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
	    'S': date.getMilliseconds(), // 毫秒
	    'w': date.getDay(), // 周
	    'W': a[date.getDay()], // 大写周
	    'T': 'T'
	  }
	  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
	  for (var k in o) {
	    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
	  }
	  return fmt
	},
  isEmail: function(email, tip) {
    return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(email);
  },
  //验证手机号
  mobile: function(phone, tip) {
    var reg = `^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$`;
    if (!phone || !phone.toString().match(reg)) {
      toast(tip);
      return false;
    } else {
      return true;
    }
  },
  appointMinLength: function(content, tip) {
    var con = content.split(';');
    if (con[0].length >= con[1]) {
      return true;
    } else {
      toast(tip);
      return false;
    }
  },
  //判断内容是否一样
  isSame: function(content, tip) {
    var con = content.split(';');
    if (con[1] === con[0]) {
      return true;
    } else {
      toast(tip);
      return false;
    }
  },
  // 6-20位数字与字母组合的密码
  password: function(content, tip) {
    var reg = new RegExp('^[a-zA-Z0-9]{6,20}$');
    if (reg.test(content)) {
      return true;
    } else {
      toast(tip);
      return false;
    }
  },
  isIdCard: function(code, tip) {
    let IdentityCodeValid = (code) => {
      var city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 "
      };
      var tip = "";
      var pass = true;

      if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = "身份证号格式错误";
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        tip = "地址编码错误";
        pass = false;
      } else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split('');
          //∑(ai×Wi)(mod 11)
          //加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          //校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
          var sum = 0;
          var ai = 0;
          var wi = 0;
          for (var i = 0; i < 17; i++) {
            ai = code[i];
            wi = factor[i];
            sum += ai * wi;
          }
          var last = parity[sum % 11];
          if (parity[sum % 11] != code[17]) {
            tip = "校验位错误";
            pass = false;
          }
        }
      }
      return pass;
    }
    return IdentityCodeValid(code)
  }
}



// WEBPACK FOOTER //
// ./src/utils/verify.js